import { connect } from 'react-redux'
import { HISTORY_ACTION } from './actionTypes'
import { userSelector } from './selectors/baseSelectors'
import * as Sentry from '@sentry/browser'
import firebase from 'firebase/app'

// import FirebaseRulesTest from 'firebase-rules-testing'
// import rules from '../../database.rules.json'
// const testFirebase = new FirebaseRulesTest(rules)

export const connectWithAuth = connect(({ firebase }) => ({
  auth: firebase.auth
}))

export const firebaseAction = func => (dispatch, getState) => {
  const database = firebase.database()
  return func(
    updates => {
      // if this action is reversable, store it in history
      if (updates.backward && Object.keys(updates.backward).length) {
        dispatch({ type: HISTORY_ACTION, payload: updates })
      }

      return database
        .ref()
        .update(updates.forward)
        .catch(err => {
          if (err.code === 'PERMISSION_DENIED') {
            console.warn('Firebase Permission Denied', {
              error: err,
              update: updates.forward
            })
            if (
              process.env.NODE_ENV === 'production' ||
              !process.env.REACT_APP_NO_SENTRY
            ) {
              Sentry.withScope(scope => {
                scope.setExtra('update', updates.forward)
                scope.setLevel('warning')
                Sentry.captureMessage(
                  `Firebase Permission Denied at ${Object.keys(
                    updates.forward
                  ).join(',')}`
                )
              })
            }
          } else {
            console.error(err)
          }
        })
    },
    {
      dispatch,
      getState,
      getKey: () => database.ref().push().key,
      getAuth: () => userSelector(getState()),
      getOnce: path =>
        database
          .ref()
          .child(path)
          .once('value')
          .then(snap => snap.val())
    }
  )
  //
  // const updates = func(dispatch, getState, {
  //   getKey: () => getFirebase().database().ref().push().key,
  //   getDatabase: () => getFirebase().database()
  // })
  // if (!updates) return
  //
  // return Promise.resolve(updates)
  // .then(updates => {
  //   // if this action is reversable, store it in history
  //   if (Object.keys(updates.backward).length) {
  //     dispatch({ type: HISTORY_ACTION, payload: updates })
  //   }
  //
  //   if (updates.action) dispatch(updates.action)
  //
  //   return firebase.update(updates.forward)
  // })
}
